import React from "react"
import { Row, Col } from "react-bootstrap"
import { useDispatch } from "react-redux"
import PassedAwayImg from "../../content/img/PA/PassedAway.png"
import InsuredDisabledImg from "../../content/img/PA/PermanentlyDisabled.png"
import RequiredMedicalAttentionImg from "../../content/img/PA/OutPatientMedical.png"
import ChildImg from "../../content/img/PA/Child.svg"
import LossAndDamageOfBicycleImg from "../../content/img/PA/DamageLoss.png"
import OptionalImg from "../../content/img/PA/Optional.svg"
import OtherImg from "../../content/img/PA/Others.png"
import * as Constants from "../../common/constants"
import {
  chooseBenefitDetail,
  controlLoading,
  removeChosenedBenefit,
  updateDropdown,
  // updateUiProperty,
  updateUiProperty,
} from "../../redux/actions"
import Swal from "sweetalert2"
import * as API from "../../services/httpService"

const BenefitSelection = ({ claimData, uiData }) => {
  const {
    pageNumber,
    coverageHeaderList,
    chosenedBenefits,
    tempBenefitInfo,
    folderName,
    claimUploadListModel,
    hideHeaderFooter,
  } = uiData
  const { claimAttributeModel } = claimData

  const dispatch = useDispatch()

  const RemoveBenefitWarning = Swal.mixin({
    customClass: {
      confirmButton: "swal-button--yes",
      cancelButton: "swal-button--no",
      actions: "swal-footer",
    },
    buttonsStyling: false,
  })

  const iconImgName = Id => {
    switch (Id) {
      case Constants.passedAwayCoverageHeaderId:
        return PassedAwayImg
      case Constants.insuredDisabledCoverageHeaderId:
        return InsuredDisabledImg
      case Constants.requiredMedicalAttentionCoverageHeaderId:
        return RequiredMedicalAttentionImg
      case Constants.childCoverageHeaderId:
        return ChildImg
      case Constants.lossAndDamageOfBicycleCoverageHeaderId:
        return LossAndDamageOfBicycleImg
      case Constants.optionalCoverageHeaderId:
        return OptionalImg
      case Constants.otherCoverageHeaderId:
        return OtherImg
      default:
        break
    }
  }

  const benefitIsChosen = Id => {
    const result = chosenedBenefits.find(e => e["CoverageDetailId"] === Id)
    return typeof result !== "undefined" ? true : false
  }

  const benefitIsNotAllow = (DetailId, GroupId) => {
    const result = chosenedBenefits.find(e => {
      return (
        e["Group_Id"] &&
        e["Group_Id"] === GroupId &&
        e["CoverageDetailId"] !== DetailId
      )
    })
    return typeof result !== "undefined" ? true : false
  }

  // const callBenefitLevelApiAndUpdateStatus = (
  //   coverageCode,
  //   Category,
  //   coverageCodeToStore,
  //   propertyNameToStore
  // ) => {
  //   API.apiPostRequest(
  //     "/Claim/GetBenefitLevel",
  //     {
  //       BenefitPlan: claimAttributeModel.planType,
  //       ProductCode: claimAttributeModel.ProductType,
  //       ReserveCode: coverageCode,
  //       ClaimantAge: 0,
  //       PurchaseDate: null,
  //     },
  //     null
  //   ).then(response => {
  //     // console.log(response)
  //     batch(() => {
  //       dispatch(
  //         updateCategoryClaimData(
  //           Category,
  //           coverageCodeToStore,
  //           propertyNameToStore,
  //           response.data.MaxAmount
  //         )
  //       )

  //       const benefitLevelStatus =
  //         response.data.MaxAmount !== -1 ? "True" : "False"

  //       dispatch(
  //         storeClaimAttributeModel("benefitLevelStatus", benefitLevelStatus)
  //       )
  //     })
  //   })
  // }

  const routeToBenefitSupportDocument = (
    detailInfo,
    coverageCode,
    Category
  ) => {
    dispatch(controlLoading())

    API.apiPostRequest(
      "/Claim/GetRequiredDocumentList",
      {
        coverageId: detailInfo.CoverageDetailId,
      },
      null
    ).then(
      requiredDocumentListResponse => {
        let apiResult = requiredDocumentListResponse.data

        if (["CAD", "AMCIM", "PD"].includes(coverageCode)) {
          let indexOfTargetDocumentId = apiResult
            .map(function(e) {
              return e.documentId
            })
            .indexOf(Constants.birthCertificateDocumentId)

          if (indexOfTargetDocumentId !== -1) {
            apiResult[indexOfTargetDocumentId].mandatory = true
          }
        }

        dispatch(chooseBenefitDetail(detailInfo, apiResult))

        dispatch(controlLoading())
      },
      error => {
        //console.log(error)
        dispatch(controlLoading())
      }
    )
    // console.log(coverageCode)
    if (claimAttributeModel.planType === null) {
      claimAttributeModel.planType = "C"
    }
    if (
      claimAttributeModel.ProductType === null ||
      claimAttributeModel.ProductType === ""
    ) {
      claimAttributeModel.ProductType = "PCE"
    }

    // callBenefitLevelApiAndUpdateStatus(
    //   coverageCode,
    //   Category,
    //   coverageCode,
    //   "MaxAmount"
    // )

    const benefitFormObject = {
      AD: "DeathForm",
      CAD: "DeathForm",
      AP: "DisablementForm",
      AT: "DisablementForm",
      PD: "DisablementForm",
      ME: "MedicalExpensesForm",
      AM: "MedicalExpensesForm",
      AMBI: "MedicalExpensesForm",
      AMID: "MedicalExpensesForm",
      AMFR: "MedicalExpensesForm",
      AMCM: "MedicalExpensesForm",
      AMIM: "MedicalExpensesForm",
      AMDT: "MedicalExpensesForm",
      AMSG: "MedicalExpensesForm",
      AMCIM: "MedicalExpensesForm",
      HA: "HospitalAllowanceForm",
      BAD: "BicycleClaimsForm",
      BMD: "BicycleClaimsForm",
      BL: "BicycleClaimsForm",
      BTH: "BicycleClaimsForm",
      OB: "OtherBenefitsForm",
    }

    let tableNames = []
    switch (benefitFormObject[coverageCode]) {
      case "DeathForm":
        tableNames.push("PA_CLAIM_OCCURRENCE_NATURE")
        break
      case "DisablementForm":
        tableNames.push("PA_CLAIM_OCCURRENCE_NATURE")
        tableNames.push("PA_CLAIM_DISABLEMENT_ACC_DESC")
        break
      case "MedicalExpensesForm":
        tableNames.push("PA_CLAIM_DOCTOR_TYPE")
        break
      case "BicycleClaimsForm":
        tableNames.push("PA_CLAIM_BICYCLE_NATURE")
        tableNames.push("PA_CLAIM_BICYCLE_DAMAGE_CAUSE")
        tableNames.push("PA_CLAIM_BICYCLE_DAMAGE_PART")
        break
      case "OtherBenefitsForm":
        tableNames.push(
          "PA_CLAIM_" + claimAttributeModel.ProductType + "_OTHER_BENEFIT"
        )
        break
      default:
    }

    for (var tableName of tableNames) {
      API.apiPostRequest("/Claim/CommonDropDownList", null, {
        params: {
          name: tableName,
        },
      }).then(response => {
        dispatch(
          updateDropdown(response.data.TableName, response.data.CodeTables)
        )
      })
    }

    if (
      coverageCode === "AP" ||
      coverageCode === "AT" ||
      coverageCode === "PD"
    ) {
      API.apiPostRequest("/Claim/PADisablementList", null, {
        params: {
          productType: claimAttributeModel.ProductType,
        },
      }).then(response => {
        // console.log(response)
        dispatch(updateUiProperty("disablementList", response.data))
      })
    }
  }

  const removeBenefit = (e, CoverageDetailId) => {
    if (!e.target.classList.contains("editBenefitsIcon")) {
      RemoveBenefitWarning.fire({
        title: "Do you want to remove this claim?",
        icon: "warning",
        scrollbarPadding: false,
        showCancelButton: true,
        confirmButtonColor: "#ff3333",
        cancelButtonColor: "#fff",
        confirmButtonText: "Yes, I do",
        cancelButtonText: "No, I don’t",
        focusConfirm: false,
      }).then(result => {
        if (result.value) {
          let thisCoverageUploadedList = claimUploadListModel.filter(doc => {
            return doc.coverageDetailId === CoverageDetailId
          })

          let deleteMultipleFileArray = []

          thisCoverageUploadedList.forEach((UploadedItem, UploadedKey) => {
            let deleteFileInfo = {}
            deleteFileInfo.fName = UploadedItem.fileName
            deleteFileInfo.folderName = folderName
            deleteMultipleFileArray.push(deleteFileInfo)
          })

          dispatch(removeChosenedBenefit(CoverageDetailId))

          API.apiPostRequest(
            "/Claim/ClaimDocsMultipleDelete",
            deleteMultipleFileArray,
            null
          ).then(response => {})
        }
        return false
      })
    }
  }

  const checkCoverageDetailIsValid = coverageCode => {
    switch (coverageCode) {
      // case Constants.homeCoverCoverageCode:
      //   //If upStatus === "True" and Home Cover add on amount is 0 means policy not covered this benefit
      //   return categoryClaimData.claimAttributeModel.upStatus === "True" &&
      //     !categoryClaimData.claimInfo.policyInfo.addOnHomeCoverAmount
      //     ? false
      //     : true
      //   break
      default:
        return true
    }
  }

  const createCoverageDetail = () => {
    let coverageDetailArray = []
    coverageHeaderList.forEach((HeaderItem, HeaderKey) => {
      if (HeaderItem.CoverageHeaderId === tempBenefitInfo.CoverageHeaderId) {
        coverageHeaderList[HeaderKey].CoverageDetails.forEach(
          (DetailItem, DetailKey) => {
            if (
              DetailItem.IsValid &&
              checkCoverageDetailIsValid(DetailItem.CoverageCode)
            ) {
              // let coverageHeaderId =
              //   coverageHeaderList[HeaderKey].CoverageHeaderId
              let detailName =
                coverageHeaderList[HeaderKey].CoverageDetails[DetailKey]
                  .CoverageDetailName
              let detailInfo =
                coverageHeaderList[HeaderKey].CoverageDetails[DetailKey]
              let coverageCode =
                coverageHeaderList[HeaderKey].CoverageDetails[DetailKey]
                  .CoverageCode
              let Category =
                coverageHeaderList[HeaderKey].CoverageDetails[DetailKey]
                  .Category

              coverageDetailArray.push(
                <Row key={DetailKey}>
                  <Col
                    xs={12}
                    className={
                      "marginTop10px CheckBox " +
                      (benefitIsChosen(DetailItem.CoverageDetailId)
                        ? "tick"
                        : "") +
                      " " +
                      (benefitIsNotAllow(
                        DetailItem.CoverageDetailId,
                        DetailItem.Group_Id
                      )
                        ? "notAllow"
                        : "")
                    }
                    onClick={e => {
                      if (
                        !benefitIsNotAllow(
                          DetailItem.CoverageDetailId,
                          DetailItem.Group_Id
                        )
                      ) {
                        if (!benefitIsChosen(DetailItem.CoverageDetailId)) {
                          routeToBenefitSupportDocument(
                            detailInfo,
                            coverageCode,
                            Category
                          )
                        } else {
                          removeBenefit(e, DetailItem.CoverageDetailId)
                        }
                      }
                    }}
                  >
                    {detailName}
                    {benefitIsChosen(DetailItem.CoverageDetailId) && (
                      <span
                        className="editBenefitsIcon ml-1"
                        role="button"
                        onClick={() => {
                          routeToBenefitSupportDocument(
                            detailInfo,
                            coverageCode,
                            Category
                          )
                        }}
                        onKeyDown={() => {
                          routeToBenefitSupportDocument(
                            detailInfo,
                            coverageCode,
                            Category
                          )
                        }}
                        tabIndex="0"
                      ></span>
                    )}
                  </Col>
                </Row>
              )
            }
          }
        )
      }
    })
    return coverageDetailArray
  }

  return (
    <Row className={pageNumber !== Constants.benefitPageNumber ? "hide" : ""}>
      <div
        className={
          "title text-center " +
          " " +
          (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
        }
      >
        Select the claim type you wish to submit
      </div>
      <Row className="containerBody marginTop3x formContainerLightYellow">
        <Col
          xs={{ span: 12, offset: 0 }}
          md={{ span: 12, offset: 0 }}
          className="formContainer formContainerLightYellow"
        >
          <div className="horizontal-align marginBottom1x">
            <Col xs={12} md={12}>
              <div className="titleText bgTransparent">Personal Accident claim category</div>
            </Col>
          </div>{" "}
          <Row>
            <Col className="benefitsHeader">
              <span className="ClaimTypeDetailText">
                <img
                  className="ClaimTypeDetailIcon"
                  alt=""
                  src={iconImgName(tempBenefitInfo.CoverageHeaderId)}
                ></img>
                {tempBenefitInfo.CoverageHeaderName}
              </span>
            </Col>
          </Row>
          <Row>
            <Col className="ml-4 mt-3">{createCoverageDetail()}</Col>
          </Row>
        </Col>
      </Row>
    </Row>
  )
}

export default BenefitSelection
